import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import ActivePage from "../../partials/active-page";
import { appName } from "../../app.json";
import * as qs from "query-string";
import { Redirect } from "react-router-dom";
import DropdownList from "./partial/DropdownList";
import { useMutation } from "@apollo/react-hooks";
import { NEW_NEXT_KIN } from "../../queries/patient.query";
import LoadingSpinner from "../../partials/loading";
import AlertMessage from "../../partials/alertMessage";
import auth from "../../providers/Auth.Provider";
import { sendNotification } from "../../sockette";
import { ReadData } from "../../providers/Patient.Provider";
import { ACTION_TYPE, EVENT_TARGET } from "../../event/model";

function NextOfKin({ location, history, match }) {
    // Get patient reference
    const { ref } = qs.parse(location.search, {
        ignoreQueryPrefix: true,
    });
    const { id } = match.params;
    const _profileLink = `/home/patient/profile/${ref || id}/summary`;
    // Authentication
    const { LogOut, IsAuthenticationError } = auth.authProvider;
    const patient = ReadData();

    // local State
    const [relation, setRelationship] = useState(null);
    const nameRef = useRef();
    const telRef = useRef();
    const addressRef = useRef();

    // Mutation query
    const [createFunc, { loading, error }] = useMutation(NEW_NEXT_KIN, {
        onCompleted: (data) => {
            if (data.NewNextOfKin) {
                const { doc } = data.NextOfKin;
                sendNotification({ ...patient, nextOfKin: doc }, ACTION_TYPE.UPDATE, EVENT_TARGET.PATIENT);
                document.location.href = _profileLink;
            }
        },
    });

    const title = "Next of Kin";

    const pages = [
        {
            title: "Patients",
            path: "/home/clinical-note/patient",
        },
        {
            title: "Profile",
            path: _profileLink,
        },
        { title, path: location.pathname },
    ];

    if (!ref && !id)
        return (
            <Redirect
                to={{
                    pathname: _profileLink,
                }}
            />
        );
    if (error && IsAuthenticationError(error.message)) {
        LogOut();
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    search: `?redirect=${location.pathname}`,
                }}
            />
        );
    }
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <ActivePage title={title} pages={pages} />

            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-head">
                            <header>
                                <button
                                    onClick={() => {
                                        history.push(_profileLink);
                                    }}
                                    title="Back"
                                    className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                >
                                    <i className="material-icons text-primary">keyboard_backspace</i>
                                </button>
                                {title} Form
                            </header>
                        </div>
                        <div className="card-body m-b-20">
                            <form
                                onSubmit={async (evt) => {
                                    evt.preventDefault();
                                    //
                                    await createFunc({
                                        variables: {
                                            model: {
                                                name: nameRef.current.value,
                                                address: addressRef.current.value,
                                                tel_phone: telRef.current.value,
                                                relationship_to_patient: relation,
                                            },
                                            id: ref,
                                        },
                                    });
                                }}
                            >
                                <div className="form-row">
                                    <div className="col">
                                        <label className="control-label" htmlFor="next_name">
                                            Name
                                            <span className="required"> * </span>
                                        </label>
                                        <input type="text" name="next_name" id="next_name" required ref={nameRef} placeholder="enter full name" className="form-control input-height" />
                                    </div>
                                    <div className="col">
                                        <label className="control-label" htmlFor="tel_number">
                                            Telephone Number
                                            <span className="required"> * </span>
                                        </label>
                                        <input type="tel_number" id="tel_number" name="name" ref={telRef} required placeholder="enter telephone" className="form-control input-height" />
                                    </div>
                                </div>
                                <div className="form-group m-t-20">
                                    <DropdownList
                                        title="Relation to patient"
                                        items={[
                                            {
                                                id: 1,
                                                name: "Father",
                                            },
                                            {
                                                id: 2,
                                                name: "Mother",
                                            },
                                            {
                                                id: 3,
                                                name: "Brother",
                                            },
                                            {
                                                id: 7,
                                                name: "Sister",
                                            },
                                            {
                                                id: 4,
                                                name: "Relative",
                                            },
                                            {
                                                id: 5,
                                                name: "Guardian",
                                            },
                                        ]}
                                        onSelect={(item) => setRelationship(item.name)}
                                    />
                                </div>
                                <div className="form-group m-t-20">
                                    <label className="control-label" htmlFor="address_id">
                                        Contact Address
                                        <span className="required"> * </span>
                                    </label>
                                    <textarea
                                        name="address-id"
                                        id="address-id"
                                        className="form-control form-control-textarea"
                                        required
                                        ref={addressRef}
                                        rows="6"
                                        placeholder="enter contact address"
                                    ></textarea>
                                </div>
                                <div>
                                    <LoadingSpinner loading={loading} />
                                    <AlertMessage message={error && error.message} failed={true} />
                                </div>
                                <div className="form-group text-right m-t-20">
                                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success">
                                        Submit
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            history.push(_profileLink);
                                        }}
                                        className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle"
                                    >
                                        Cancel <i className="material-icons text-danger">close</i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default NextOfKin;
